import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

// Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";

// Pages
const User = () => import("@/pages/Dashboard/Pages/UserProfile.vue");
const TimeLine = () => import("@/pages/Dashboard/Pages/TimeLinePage.vue");
const Login = () => import("@/pages/Dashboard/Pages/Login.vue");
const Lock = () => import("@/pages/Dashboard/Pages/Lock.vue");

const NewIssue = () => import("@/pages/Issues/NewIssue.vue");
const NewIssueCustomer = () => import("@/pages/Issues/NewIssueCustomer.vue");
const CustomerNewIssue = () => import("@/pages/Issues/Customer/CustomerNewIssue.vue");
const ConsumerNewIssue = () => import("@/pages/Issues/Consumer/ConsumerNewIssue.vue");

const reclamacionesNew = () => import("@/pages/Issues/ReclamacionesClienteView");
const reclamacionesConsumidor = () => import("@/pages/Issues/ReclamacionesConsumidorView");

// Calendar
const Calendar = () => import("@/pages/Dashboard/Calendar.vue");
// Charts
const Charts = () => import("@/pages/Dashboard/Charts.vue");
import Widgets from "@/pages/Dashboard/Widgets.vue";

let pagesMenu = {
  path: "/pages",
  component: DashboardLayout,
  name: "Pages",
  redirect: "/pages/user",
  children: [
    {
      path: "user",
      name: "User Page",
      components: {
        default: User
      }
    },
    {
      path: "timeline",
      name: "Timeline Page",
      components: {
        default: TimeLine
      }
    }
  ]
};

let issuesMenu = {
  path: "/issues",
  component: DashboardLayout,
  name: "Reclamaciones",
  redirect: "/issues",
  children: [{
    path: "/",
    name: "Reclamaciones",
    components: {
      default: Dashboard
    }
  },
  {
    path: "new",
    name: "Nueva Reclamación",
    components: {
      default: NewIssue
    }
  },
  {
    path: "reclamacionView/:id",
    name: "Reclamación",
    components: {
      default: reclamacionesNew
    }
  },
  {
    path: "reclamacionConsumidorView/:id",
    name: "Reclamación",
    components: {
      default: reclamacionesConsumidor
    }
  },
  {
    path: "newcustomer",
    name: "Nueva Reclamación",
    components: {
      default: NewIssueCustomer
    }
  },
  {
    path: "newcustomerissue",
    name: "Nueva Reclamación Cliente",
    components: {
      default: CustomerNewIssue
    }
  },
  {
    path: "newconsumerissue",
    name: "Nueva Reclamación Consumidor",
    components: {
      default: ConsumerNewIssue
    }
  }
  ]
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/lock",
      name: "Lock",
      component: Lock
    }
  ]
};

const routes = [
  {
    path: "/",
    redirect: "/dashboard",
    name: "Home"
  },
  pagesMenu,
  issuesMenu,
  authPages,
  {
    path: "/",
    component: DashboardLayout,
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        components: {
          default: Dashboard
        }
      },
      {
        path: "calendar",
        name: "Calendar",
        components: {
          default: Calendar
        }
      },
      {
        path: "charts",
        name: "Charts",
        components: {
          default: Charts
        }
      },
      {
        path: "widgets",
        name: "Widgets",
        components: {
          default: Widgets
        }
      }
    ]
  }
];

export default routes;
